<template>
  <div class="leftThree">
    <commonHeader title="手动报备统计"></commonHeader>
    <section class="statisCon">
      <div class="statisChart" v-if="chartData.data.length > 0">
        <radarChart :chartData="chartData" id="radarChart"></radarChart>
      </div>
      <div class="no-data" v-else>暂无数据</div>
      <ul class="rightInfo">
        <li class="info_item">
          <div class="top">
            <span class="mark"></span>
            <span class="title">全部报备数量</span>
          </div>
          <div class="num">
            <span>{{ reportData.reportAll }}</span>
          </div>
        </li>
        <li class="info_item">
          <div class="top">
            <span class="mark"></span>
            <span class="title">已报备数量</span>
          </div>
          <div class="num">
            <span>{{ reportData.reportHand }}</span>
          </div>
        </li>
        <li class="info_item">
          <div class="top">
            <span class="mark"></span>
            <span class="title">未报备数量</span>
          </div>
          <div class="num">
            <span>{{ reportData.reportNo }}</span>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
  import commonHeader from '../commonHeader.vue'
  import radarChart from './radarChart'
  export default {
    name: 'leftThree',
    props: {
      areaId: {
        type: String | Number
      }
    },
    watch: {
      areaId: {
        handler(val) {
          this.getData()
          this.startTimer()
        },
        immediate: true
      }
    },
    components: {
      commonHeader,
      radarChart
    },
    data() {
      return {
        reportData: {},
        chartData: {
          xdata: [],
          data: []
        },
        timer: null
      }
    },
    methods: {
      getData() {
        this.$axiospost('operation/automatic/hand/detection/queryLeftThreeStatics', {
          parentAreaId: this.areaId
        }).then(res => {
          if (res.data.status == 10000) {
            const { reportAll, reportHand, reportNo } = res.data.data
            this.reportData = { reportAll, reportHand, reportNo }
            this.chartData.data =
              res.data.data.typeCount.length > 0
                ? res.data.data.typeCount.map(item => item.count)
                : []

            let max = Math.max(...this.chartData.data)
            this.chartData.xdata =
              res.data.data.typeCount.length > 0
                ? res.data.data.typeCount.map(item => {
                    return {
                      name: item.name,
                      max: max
                    }
                  })
                : []
          }
        })
      },
      // 新增：启动定时器
      startTimer() {
        this.stopTimer() // 先清除可能存在的定时器
        this.timer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 新增：停止定时器
      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.stopTimer)
    }
  }
</script>

<style lang="less" scoped>
  .leftThree {
    width: 100%;
    height: calc(100% - 29.5vh - 26.34vh);

    .statisCon {
      height: calc(100% - 5vh);
      display: flex;
      justify-content: center;
      align-items: center;

      .statisChart {
        width: 2.8rem;
        height: 100%;
        background-image: url('./circle.png');
        background-size: 80% auto;
        background-repeat: no-repeat;
        background-position: center;
      }

      .no-data {
        width: 2.8rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3vh;
        color: rgba(255, 255, 255, 0.6);
      }

      .rightInfo {
        margin-left: 0.2rem;
        .info_item {
          min-width: 1.27rem;

          &:not(:first-child) {
            margin-top: 1.4vh;
          }

          .top {
            display: flex;
            justify-content: center;
            align-items: center;

            .mark {
              display: inline-block;
              margin-right: 0.05rem;
              width: 0.08rem;
              height: 0.08rem;
              background-image: linear-gradient(-19deg, #1995ff 0%, #e1efff 54%, #ffffff 100%),
                linear-gradient(#b8d2ff, #b8d2ff);
              background-blend-mode: normal, normal;
            }

            .title {
              font-family: MicrosoftYaHei;
              font-size: 1.11vh;
              color: #ffffff;
            }
          }

          .num {
            margin-top: 1.21vh;
            height: 1.48vh;
            background-image: url('./one.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            span {
              position: absolute;
              bottom: 0.38vh;
              left: 50%;
              transform: translateX(-50%);
              font-family: MicrosoftYaHei;
              font-weight: bold;
              font-size: 1.85vh;
              color: #4abdff;
            }
          }

          &:nth-child(2) {
            .num {
              background-image: url('./two.png');
              span {
                color: #48ffff;
              }
            }
          }

          &:nth-child(3) {
            .num {
              background-image: url('./three.png');
              span {
                color: #ffeba5;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/leftThree/index.vue